"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PreferencesV4 = exports.PreferenceSections = exports.PreferenceTopic = exports.Channel = exports.Input = exports.ChannelOption = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactHooks = require("@trycourier/react-hooks");

var _StyledToggle = require("./StyledToggle");

var _reactToggle = _interopRequireDefault(require("react-toggle"));

var _DigestSchedule = _interopRequireDefault(require("./DigestSchedule"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var ChannelOption = _styledComponents["default"].div.withConfig({
  displayName: "PreferencesV4__ChannelOption",
  componentId: "sc-mtobke-0"
})(["display:flex;height:20px;padding:0 10px;gap:5px;background:transparent;border-radius:12px;border:1px solid black;whitespace:nowrap;font-style:normal;font-weight:500;font-size:10px;line-height:16px;justify-content:center;align-items:center;svg{display:normal;}"]);

exports.ChannelOption = ChannelOption;

var PreferenceSectionWrapper = _styledComponents["default"].div.withConfig({
  displayName: "PreferencesV4__PreferenceSectionWrapper",
  componentId: "sc-mtobke-1"
})(["width:100%;"]);

var SectionHeader = _styledComponents["default"].h1.withConfig({
  displayName: "PreferencesV4__SectionHeader",
  componentId: "sc-mtobke-2"
})(["margin:0;font-size:24px;"]);

var StyledItem = _styledComponents["default"].div.withConfig({
  displayName: "PreferencesV4__StyledItem",
  componentId: "sc-mtobke-3"
})(["padding:16px 0;margin-top:6px;border-radius:4px;.template-name{font-size:14px;white-space:nowrap;text-overflow:ellipsis;width:100%;margin-bottom:6px;font-weight:bold;}.digest-schedules{margin-top:16px;}"]);

var Check = _styledComponents["default"].svg.withConfig({
  displayName: "PreferencesV4__Check",
  componentId: "sc-mtobke-4"
})(["fill:white;"]);

var Input = _styledComponents["default"].input.withConfig({
  displayName: "PreferencesV4__Input",
  componentId: "sc-mtobke-5"
})(["position:absolute;opacity:0;cursor:pointer;height:0;width:0;"]);

exports.Input = Input;

var Channel = _styledComponents["default"].div.withConfig({
  displayName: "PreferencesV4__Channel",
  componentId: "sc-mtobke-6"
})(["display:flex;align-items:center;justify-content:center;label{position:relative;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;}", ":checked ~ ", "{background:", ";border:0;}", ":checked ~ ", " > div{color:white;}"], Input, ChannelOption, function (_ref) {
  var _theme$primary;

  var theme = _ref.theme;
  return (_theme$primary = theme === null || theme === void 0 ? void 0 : theme.primary) !== null && _theme$primary !== void 0 ? _theme$primary : "#9121c2";
}, Input, ChannelOption);

exports.Channel = Channel;

var ChannelPreferenceStyles = _styledComponents["default"].div.withConfig({
  displayName: "PreferencesV4__ChannelPreferenceStyles",
  componentId: "sc-mtobke-7"
})(["display:flex;flex-wrap:wrap;justify-content:end;align-items:center;gap:0.25rem;margin-top:15px;background:rgba(213,221,228,0.4);border-radius:15px;padding:5px;p{margin:0;}.customize-delivery{input{display:none;opacity:0;width:0;height:0;}display:flex;flex-grow:1;align-items:center;p{font-size:12px;}div{width:20px;height:20px;border:solid 1px black;border-radius:100%;margin:0 2.5px;position:static;display:flex;align-items:center;}", ":checked ~ div > ", "{fill:white;}", ":checked ~ div{border:0;background-color:", ";svg{margin-left:5px;}}}"], Input, Check, Input, function (_ref2) {
  var _theme$primary2;

  var theme = _ref2.theme;
  return (_theme$primary2 = theme === null || theme === void 0 ? void 0 : theme.primary) !== null && _theme$primary2 !== void 0 ? _theme$primary2 : "#9121c2";
});

var SubscriptionDivider = _styledComponents["default"].hr.withConfig({
  displayName: "PreferencesV4__SubscriptionDivider",
  componentId: "sc-mtobke-8"
})(["width:100%;border-bottom:1px #f5f5f5 solid;"]);

var Checkmark = function Checkmark() {
  return /*#__PURE__*/_react["default"].createElement(Check, {
    viewBox: "0 0 9 8",
    height: "10px",
    width: "10px"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3.0005 7.09954C2.84689 7.09954 2.69328 7.04074 2.57567 6.92433L0.175512 4.52417C-0.0585039 4.29015 -0.0585039 3.90973 0.175512 3.67571C0.409527 3.4417 0.789953 3.4417 1.02397 3.67571L3.0005 5.65104L7.97603 0.675512C8.21005 0.441496 8.59047 0.441496 8.82449 0.675512C9.0585 0.909527 9.0585 1.28995 8.82449 1.52397L3.42413 6.92433C3.30772 7.04074 3.15411 7.09954 3.0005 7.09954Z"
  }));
};

var DisplayChannel = function DisplayChannel(channel) {
  if (channel === "direct_message") {
    return "Chat";
  } else if (channel === "sms") {
    return "SMS";
  }

  return channel.charAt(0).toUpperCase() + channel.slice(1);
};

var ChannelPreference = function ChannelPreference(_ref3) {
  var handleChannelRouting = _ref3.handleChannelRouting,
      routingPreferences = _ref3.routingPreferences,
      channel = _ref3.channel;

  var _useState = (0, _react.useState)(routingPreferences.includes(channel)),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      checked = _useState2[0],
      setChecked = _useState2[1];

  var _usePreferences = (0, _reactHooks.usePreferences)(),
      preferencePage = _usePreferences.preferencePage;

  return /*#__PURE__*/_react["default"].createElement(Channel, {
    theme: {
      primary: preferencePage === null || preferencePage === void 0 ? void 0 : preferencePage.brand.settings.colors.primary
    }
  }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement(Input, {
    type: "checkbox",
    onChange: function onChange() {
      handleChannelRouting(channel);
      setChecked(!checked);
    },
    checked: checked
  }), /*#__PURE__*/_react["default"].createElement(ChannelOption, null, checked && /*#__PURE__*/_react["default"].createElement(Checkmark, null), /*#__PURE__*/_react["default"].createElement("div", null, DisplayChannel(channel)))));
};

var PreferenceTopic = function PreferenceTopic(_ref4) {
  var _topic$digestSchedule, _preferencePage$brand;

  var topic = _ref4.topic,
      status = _ref4.status,
      routingPreferences = _ref4.routingPreferences,
      defaultRoutingOptions = _ref4.defaultRoutingOptions,
      hasCustomRouting = _ref4.hasCustomRouting,
      defaultHasCustomRouting = _ref4.defaultHasCustomRouting;

  var _usePreferences2 = (0, _reactHooks.usePreferences)(),
      preferencePage = _usePreferences2.preferencePage,
      updateRecipientPreferences = _usePreferences2.updateRecipientPreferences; //Temporary mapping until I update this in the backend


  var defaultStatus = topic.defaultStatus,
      topicName = topic.templateName,
      topicId = topic.templateId; // If there user hasn't set a status then use the default status to set the toggle.

  var _useState3 = (0, _react.useState)(status ? status === "OPTED_IN" : defaultStatus !== "OPTED_OUT"),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      statusToggle = _useState4[0],
      setStatusToggle = _useState4[1];

  var _useState5 = (0, _react.useState)(hasCustomRouting),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      customizeDelivery = _useState6[0],
      setCustomizeDelivery = _useState6[1];

  var _useState7 = (0, _react.useState)(routingPreferences),
      _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
      routing = _useState8[0],
      setRouting = _useState8[1];

  var handleStatusChange = function handleStatusChange() {
    // Required statuses should never change
    if (defaultStatus === "REQUIRED") {
      return;
    }

    var newStatus = statusToggle ? "OPTED_OUT" : "OPTED_IN";
    updateRecipientPreferences({
      templateId: topicId,
      status: newStatus
    });
    setStatusToggle(!statusToggle);
  };

  var handleDeliveryCustomization = function handleDeliveryCustomization() {
    updateRecipientPreferences(_objectSpread(_objectSpread({
      templateId: topicId,
      hasCustomRouting: !customizeDelivery
    }, !customizeDelivery && {
      routingPreferences: ["direct_message", "email", "inbox", "push", "sms", "webhook"]
    }), {}, {
      status: statusToggle ? "OPTED_IN" : "OPTED_OUT"
    })); // If Customize Delivery is turned on, set the routing preferences to the default

    !customizeDelivery && setRouting(["sms", "email", "direct_message", "push", "webhook"]);
    setCustomizeDelivery(!customizeDelivery);
  };

  var handleChannelRouting = function handleChannelRouting(channel) {
    var newRouting = routing.includes(channel) ? routing.filter(function (r) {
      return r !== channel;
    }) : [].concat((0, _toConsumableArray2["default"])(routing), [channel]);
    updateRecipientPreferences({
      templateId: topicId,
      routingPreferences: newRouting,
      hasCustomRouting: true,
      status: statusToggle ? "OPTED_IN" : "OPTED_OUT"
    });
    setRouting(newRouting);
  };

  var handleScheduleChange = /*#__PURE__*/function () {
    var _ref5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(scheduleId) {
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return updateRecipientPreferences({
                templateId: topicId,
                digestSchedule: scheduleId
              });

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleScheduleChange(_x) {
      return _ref5.apply(this, arguments);
    };
  }();

  if (!topic) {
    return null;
  }

  var getStatusString = function getStatusString(status) {
    return status ? "Opted In" : "Opted Out";
  };

  return /*#__PURE__*/_react["default"].createElement(StyledItem, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "template-name"
  }, topicName), /*#__PURE__*/_react["default"].createElement(_StyledToggle.StyledToggle, {
    checked: statusToggle,
    theme: {
      brand: {
        colors: {
          primary: preferencePage === null || preferencePage === void 0 ? void 0 : preferencePage.brand.settings.colors.primary
        }
      }
    }
  }, /*#__PURE__*/_react["default"].createElement("label", null, defaultStatus !== "REQUIRED" ? getStatusString(statusToggle) : "Required"), /*#__PURE__*/_react["default"].createElement(_reactToggle["default"], {
    icons: false,
    disabled: defaultStatus === "REQUIRED",
    checked: statusToggle,
    onChange: handleStatusChange
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "digest-schedules"
  }, /*#__PURE__*/_react["default"].createElement(_DigestSchedule["default"], {
    schedules: (_topic$digestSchedule = topic.digestSchedules) !== null && _topic$digestSchedule !== void 0 ? _topic$digestSchedule : [],
    checkedColor: (_preferencePage$brand = preferencePage === null || preferencePage === void 0 ? void 0 : preferencePage.brand.settings.colors.primary) !== null && _preferencePage$brand !== void 0 ? _preferencePage$brand : "#9121c2",
    onScheduleChange: handleScheduleChange,
    topicId: topicId
  })), statusToggle && defaultHasCustomRouting && defaultStatus !== "REQUIRED" && /*#__PURE__*/_react["default"].createElement(ChannelPreferenceStyles, {
    theme: {
      primary: preferencePage === null || preferencePage === void 0 ? void 0 : preferencePage.brand.settings.colors.primary
    }
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: "customize-delivery"
  }, /*#__PURE__*/_react["default"].createElement(Input, {
    type: "checkbox",
    checked: customizeDelivery,
    onClick: handleDeliveryCustomization
  }), /*#__PURE__*/_react["default"].createElement("div", null, customizeDelivery && /*#__PURE__*/_react["default"].createElement(Checkmark, null)), /*#__PURE__*/_react["default"].createElement("p", null, "Customize Delivery Channel")), customizeDelivery && defaultRoutingOptions.map(function (channel, i) {
    return /*#__PURE__*/_react["default"].createElement(ChannelPreference, {
      key: i,
      channel: channel,
      routingPreferences: routing,
      handleChannelRouting: handleChannelRouting
    });
  })));
};

exports.PreferenceTopic = PreferenceTopic;

var PreferenceSections = function PreferenceSections(_ref6) {
  var section = _ref6.section;

  var _usePreferences3 = (0, _reactHooks.usePreferences)(),
      recipientPreferences = _usePreferences3.recipientPreferences;

  var memoizedTopics = (0, _react.useMemo)(function () {
    return section.topics.nodes.map(function (topic) {
      return {
        topic: topic,
        recipientPreference: recipientPreferences === null || recipientPreferences === void 0 ? void 0 : recipientPreferences.find(function (preference) {
          if (preference.templateId === topic.templateId) {
            return preference;
          }
        })
      };
    });
  }, [section, recipientPreferences]);

  if (!recipientPreferences) {
    return null;
  }

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(SectionHeader, null, section.name), memoizedTopics.map(function (_ref7, index) {
    var _recipientPreference$;

    var topic = _ref7.topic,
        recipientPreference = _ref7.recipientPreference;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(PreferenceTopic, {
      topic: topic,
      defaultRoutingOptions: section.routingOptions,
      defaultHasCustomRouting: section.hasCustomRouting,
      hasCustomRouting: recipientPreference === null || recipientPreference === void 0 ? void 0 : recipientPreference.hasCustomRouting,
      status: recipientPreference === null || recipientPreference === void 0 ? void 0 : recipientPreference.status,
      routingPreferences: (_recipientPreference$ = recipientPreference === null || recipientPreference === void 0 ? void 0 : recipientPreference.routingPreferences) !== null && _recipientPreference$ !== void 0 ? _recipientPreference$ : []
    }), index < memoizedTopics.length - 1 && /*#__PURE__*/_react["default"].createElement(SubscriptionDivider, null));
  }));
};

exports.PreferenceSections = PreferenceSections;

var PreferenceList = _styledComponents["default"].ul.withConfig({
  displayName: "PreferencesV4__PreferenceList",
  componentId: "sc-mtobke-9"
})(["padding:0;margin:0;"]);

var PreferenceListItem = _styledComponents["default"].li.withConfig({
  displayName: "PreferencesV4__PreferenceListItem",
  componentId: "sc-mtobke-10"
})(["list-style:none;border-bottom:1px solid #e5e5e5;padding:10px 0;margin:0;:last-child{border-bottom:none;}"]); // Doesn't include header or footer


var PreferencesV4 = function PreferencesV4(_ref8) {
  var _preferences$preferen, _preferences$preferen2;

  var accountId = _ref8.accountId,
      draft = _ref8.draft;
  var preferences = (0, _reactHooks.usePreferences)();
  (0, _react.useEffect)(function () {
    var pullPreferences = /*#__PURE__*/function () {
      var _ref9 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(!preferences.preferencePage && !preferences.recipientPreferences)) {
                  _context2.next = 5;
                  break;
                }

                _context2.next = 3;
                return preferences.fetchPreferencePage(accountId, draft);

              case 3:
                _context2.next = 5;
                return preferences.fetchRecipientPreferences();

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function pullPreferences() {
        return _ref9.apply(this, arguments);
      };
    }();

    pullPreferences();
  }, []);

  if (!preferences.preferencePage && !preferences.isLoading) {
    return /*#__PURE__*/_react["default"].createElement("div", null, "This page is not avaliable. Please contact your administrator.");
  }

  return /*#__PURE__*/_react["default"].createElement(PreferenceSectionWrapper, null, /*#__PURE__*/_react["default"].createElement(PreferenceList, null, preferences === null || preferences === void 0 ? void 0 : (_preferences$preferen = preferences.preferencePage) === null || _preferences$preferen === void 0 ? void 0 : (_preferences$preferen2 = _preferences$preferen.sections) === null || _preferences$preferen2 === void 0 ? void 0 : _preferences$preferen2.nodes.map(function (section, i) {
    return /*#__PURE__*/_react["default"].createElement(PreferenceListItem, {
      key: i
    }, /*#__PURE__*/_react["default"].createElement(PreferenceSections, {
      section: section
    }));
  })));
};

exports.PreferencesV4 = PreferencesV4;